module.exports = __webpack_public_path__ + "img/webapps.aabe03ae.svg";